/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Sign_In_TitleInputs */

const en_directory_submit_sign_in_title = /** @type {(inputs: Directory_Submit_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to submit`)
};

const zh_directory_submit_sign_in_title = /** @type {(inputs: Directory_Submit_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先登录`)
};

/**
* | output |
* | --- |
* | "Sign in to submit" |
*
* @param {Directory_Submit_Sign_In_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_sign_in_title = /** @type {((inputs?: Directory_Submit_Sign_In_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Sign_In_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_sign_in_title(inputs)
	return zh_directory_submit_sign_in_title(inputs)
});
export { directory_submit_sign_in_title as "directory.submit.sign_in_title" }